const VISITSVIEW = {
  listClients: "Lista de clientes",
  loadMasive: "upload em massa",
  createClient: "Criar cliente",
  updateClient: "Atualizar cliente",
  FORMCLIENT: {
    names: "Nomes",
    lastName: "Sobrenomes",
    EMAILContact: "Email de contato",
    optional: "(Opcional)",
    address: "Dirección",
    selectionTypeForm: "*Selecione o tipo de formulários a serem atribuídos:",
    standarMovil: "Padrão (aplicativo móvel)",
    botsViky: "Bots (VIKI)",
    selectedForms: "*Selecione os formulários",
    searchForm: "Formulário de pesquisa...",
    details: "Detalhes",
    update: "Atualizar",
    save: "Salvar",
    clean: "Limpar",
    address: "Endereço",
    messagge1: "Verifique se a estrutura do endereço é um exemplo: Calle 84 24 - 78, Bogotá",
    client: "Cliente",
    selectedFormsToClient: "Selecione o(s) formulário(s) para o cliente",
    errorCreateClient: "Erro ao criar cliente.",
    updatedClient: "O cliente foi atualizado.",
    errorUpdatedClient: "Erro ao atualizar o cliente.",
    message2: "Verifique se a estrutura do endereço é um exemplo: Calle 84 24 - 78, Bogotá",
    message3: "Selecione o(s) formulário(s) para o cliente",
    createdClient: "O cliente foi criado.",
    errorToCreatedClient: "Erro ao criar cliente.",
    errorToUpdateClient: "Erro ao atualizar o cliente."
  },
  LISTCLIENTS: {
    byPage: "Por página",
    client: "Cliente",
    email: "E-mail",
    phone: "Telefone",
    created: "Registrado",
    state: "Doença",
    actions: "Ações",
    deleteUser: "Deletar usuário",
    textConfirm: "Você realmente deseja excluir o usuário: {name} {lastname}"
  },
  LOADMASIVE: {
    donwloadFormat: "Formato de download",
    settingExcel: "Configuração do excel",
    selectTypeForm: "*Selecione o tipo de formulários a serem atribuídos:",
    standarMovil: "Padrão (aplicativo móvel)",
    botsViky: "Bots (VIKI)",
    none: "Nenhum",
    howManyClients: "Quantos clientes você vai registrar??",
    OrderEmail: "Você deseja solicitar o e-mail?",
    yes: "Sim",
    no: "Não",
    searchForm: "Formulário de pesquisa...",
    HEADTABLE: {
      names: "NOMES",
      lastNames: "SOBRENOMES",
      email: "O EMAIL",
      phone: "TELEFONE",
      address: "DIREÇÃO",
      details: "DETALHE"
    }
  }
};

export default { VISITSVIEW };
